export default __webpack_public_path__ + "static/media/bg-small2.e1a44b1b.png";